import axiosInstance from '../utils/axiosConfig';

/**
 * Internal (IMT staff) KYC Partner Onboarding API.
 * All endpoints are CRM-gated on the backend (HasCRMAccess).
 */
export const kycService = {
    getCases: async ({ year, status, crm_profile } = {}) => {
        const params = new URLSearchParams();
        if (year) params.append('year', year);
        if (status) params.append('status', status);
        if (crm_profile) params.append('crm_profile', crm_profile);
        const response = await axiosInstance.get(
            `/api/kyc/cases/${params.toString() ? '?' + params.toString() : ''}`
        );
        return response.data;
    },

    getCase: async (caseId) => {
        const response = await axiosInstance.get(`/api/kyc/cases/${caseId}/`);
        return response.data;
    },

    createCase: async (payload) => {
        // payload: { company_name, year, form_type, contact_email, contact_name, crm_profile_id }
        const response = await axiosInstance.post('/api/kyc/cases/', payload);
        return response.data; // { case, invite_link, email_sent }
    },

    resendInvite: async (caseId) => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/resend-invite/`);
        return response.data; // { invite_link, email_sent }
    },

    reviewCase: async (caseId, action, notes = '') => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/review/`, {
            action,
            notes,
        });
        return response.data;
    },

    runExtraction: async (caseId) => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/run-extraction/`);
        return response.data;
    },

    screenUbos: async (caseId) => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/screen-ubos/`);
        return response.data;
    },

    getDeclaration: async (caseId) => {
        const response = await axiosInstance.get(`/api/kyc/cases/${caseId}/declaration/`);
        return response.data; // { declaration, events, chain }
    },

    verifyDeclaration: async (caseId) => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/declaration/verify/`);
        return response.data; // { chain, seal }
    },

    uploadDeclarationScan: async (caseId, file) => {
        const data = new FormData();
        data.append('file', file);
        const response = await axiosInstance.post(
            `/api/kyc/cases/${caseId}/declaration/upload-scan/`,
            data,
            { headers: { 'Content-Type': 'multipart/form-data' } },
        );
        return response.data;
    },

    requestSA: async (caseId) => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/request-sa/`);
        return response.data;
    },

    startRenewal: async (caseId) => {
        const response = await axiosInstance.post(`/api/kyc/cases/${caseId}/start-renewal/`);
        return response.data; // { case, invite_link, email_sent }
    },

    downloadDocument: async (documentId, filename) => {
        const response = await axiosInstance.get(
            `/api/kyc/documents/${documentId}/download/`,
            { responseType: 'blob' }
        );
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename || 'kyc-document');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },
};

export default kycService;
